import { getApiErrorMessage } from './api-error-messages/ApiErrorMessages';
import { ApiError } from './ApiError';
import { ClientError } from './ClientError';

export const errorHandler = (error: unknown, placeholder?: string): string => {
  if (error instanceof ApiError && error.data?.client_code) {
    return getApiErrorMessage(error.data.client_code);
  }

  if (error instanceof ClientError) {
    if (error.message) return `${error.client_error_code}: ${error.message}`;
    return error.client_error_code;
  }

  return placeholder || 'Unknown error';
};
